import { Check } from '@mui/icons-material';
import { ListItemText } from '@mui/material';
import { NavListItemWithMenu, NavListItemToolTipContent, NavMenu } from '@procureai/ui-mui';
import { always } from 'ramda';
import { useTranslation } from 'react-i18next';

import { useConfig } from '~/components/ConfigProvider';
import { languageIsoCode } from '~/util/string';

const getOptionIconName = always(Check);

export const NavListItemLanguage = () => {
  const { t, i18n } = useTranslation();
  const { t: tLang } = useTranslation(undefined, { keyPrefix: 'language' });
  const { languages } = useConfig();
  return (
    <NavListItemWithMenu
      tooltip={<NavListItemToolTipContent label={t('Nav.language')} />}
      menu={
        <NavMenu
          options={languages}
          selected={i18n.language}
          selectedHasIconOnly
          getOptionIcon={getOptionIconName}
          getOptionLabel={tLang}
          onItemClick={(lng) => {
            i18n.changeLanguage(lng);
          }}
        />
      }
    >
      <ListItemText primary={languageIsoCode(i18n.language).toUpperCase()} sx={{ minWidth: 'auto' }} />
    </NavListItemWithMenu>
  );
};
